import { useState } from 'react'
import axios from 'axios'
import { vouchersService } from '../services/vouchersService'
import { clientService } from '@/modules/clients/services/clientService'
import type { BenefitVoucher } from '../types'
import type { ClientStatus } from '@/modules/clients/types'

export function useVoucher() {
  const [voucher, setVoucher] = useState<BenefitVoucher | null>(null)
  const [clientStatus, setClientStatus] = useState<ClientStatus | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const search = async (code: string) => {
    setIsLoading(true)
    setError(null)
    setVoucher(null)
    setClientStatus(null)
    try {
      const data = await vouchersService.getByCode(code.trim())
      setVoucher(data)

      // Fetch client status (category + points) in the background
      if (data.client?.id) {
        clientService.getStatus(data.client.id)
          .then(setClientStatus)
          .catch(() => { /* non-critical, ignore */ })
      }
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          setError('Vale no encontrado. Verifica el código e intenta de nuevo.')
        } else {
          const detail = err.response?.data?.detail
          setError(typeof detail === 'string' ? detail : 'Error al buscar vale')
        }
      } else {
        setError('Error al buscar vale')
      }
    } finally {
      setIsLoading(false)
    }
  }

  const clear = () => {
    setVoucher(null)
    setClientStatus(null)
    setError(null)
  }

  return { voucher, clientStatus, isLoading, error, search, clear }
}
